import { render, staticRenderFns } from "./BurgerNavigationItem.vue?vue&type=template&id=6cb5e1c9&scoped=true&"
import script from "./BurgerNavigationItem.vue?vue&type=script&lang=js&"
export * from "./BurgerNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb5e1c9",
  null
  
)

export default component.exports